var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-block-list-icon",class:{
    failed: _vm.isStatusFailed,
    success: _vm.isStatusSuccess,
    neutral: _vm.isStatusNeutral,
  }},[_c('icon',{attrs:{"name":_vm.iconName,"size":32}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }